import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';
import RoutePrivate from 'components/Route/Private/Private';
import ScreensProgramForm from 'screens/Program/ScreensProgramForm';

import ScreensCampaignList from './List/ScreensCampaignList';

function ScreensCampaign() {
  return (
    <Routes>
      <Route
        path="/list"
        element={
          <RoutePrivate
            requiredPermission="campaigns.list"
            path="/list"
            element={ScreensCampaignList}
          />
        }
      />
      <Route
        path="/:campaignId/program/create"
        element={
          <RoutePrivate
            exact
            element={ScreensProgramForm}
            requiredPermission="programs.read"
          />
        }
      />
      <Route
        path="/:campaignId/program/:id/edit"
        element={
          <RoutePrivate
            exact
            element={ScreensProgramForm}
            requiredPermission="programs.update"
          />
        }
      />
      <Route path="/" element={<Navigate replace to="/campaigns/list" />} />
    </Routes>
  );
}

export default ScreensCampaign;
